import { render, staticRenderFns } from "./CardSidebarTabComments.vue?vue&type=template&id=21edaa7e&scoped=true&"
import script from "./CardSidebarTabComments.vue?vue&type=script&lang=js&"
export * from "./CardSidebarTabComments.vue?vue&type=script&lang=js&"
import style0 from "./CardSidebarTabComments.vue?vue&type=style&index=0&id=21edaa7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21edaa7e",
  null
  
)

export default component.exports